import React from "react";
import { Spin, Empty } from "antd";
import { ApartmentOutlined, BankOutlined } from "@ant-design/icons";
import type { TeamListProps } from "./types";
import { ALL_TEAMS_ID, ALL_TEAMS_LABEL, EMPTY_TEXTS } from "./utils/constants";
import styles from "./TeamList.module.css";

const TeamList: React.FC<TeamListProps> = ({
  teams,
  loading,
  selectedTeamId,
  onTeamSelect,
}) => {
  if (loading) {
    return (
      <div className={styles.loadingState}>
        <Spin />
      </div>
    );
  }

  if (teams.length === 0) {
    return (
      <div className={styles.emptyWrapper}>
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={EMPTY_TEXTS.NO_TEAMS}
        />
      </div>
    );
  }

  const renderTeamItem = (
    id: number | null,
    name: string,
    count?: number,
    icon?: React.ReactNode
  ) => {
    const isSelected = selectedTeamId === id;

    return (
      <button
        key={id ?? "all"}
        type="button"
        onClick={() => onTeamSelect(id)}
        className={[styles.teamItem, isSelected ? styles.teamItemSelected : ""]
          .filter(Boolean)
          .join(" ")}
      >
        <div
          className={[styles.teamIcon, isSelected ? styles.teamIconSelected : ""]
            .filter(Boolean)
            .join(" ")}
        >
          {icon ?? <ApartmentOutlined />}
        </div>

        <div className={styles.teamContent}>
          <div className={styles.teamName}>{name}</div>
          <div className={styles.teamMeta}>
            {count !== undefined ? `${count} 人` : "查看此範圍成員"}
          </div>
        </div>
      </button>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerTitle}>團隊範圍</div>
        <div className={styles.headerHint}>共 {teams.length} 個團隊</div>
      </div>

      <div className={styles.content}>
        <div className={styles.list}>
          {renderTeamItem(
            ALL_TEAMS_ID,
            ALL_TEAMS_LABEL,
            undefined,
            <BankOutlined />
          )}
          {teams.map((team) =>
            renderTeamItem(team.id, team.teamName, team.number)
          )}
        </div>
      </div>
    </div>
  );
};

export default TeamList;
